import { useState } from 'react'
import { axiosGet } from '../util/api'
import History = Models.History

interface useBidHistoryReturn {
    loading: boolean
    history: History[]
    load: (id: number | string) => void
}

export const useBidHistory = (type: number): useBidHistoryReturn => {
    const [history, setHistory] = useState<History[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [historyId, setHistoryId] = useState<number | string | null>(null)

    const load = (id: number | string): void => {
        if (id === historyId) {
            // Already loaded
            return
        } else {
            setHistory([])
        }

        setLoading(true)
        setHistoryId(id)
        axiosGet(`history/${type}/${id}`)
            .then((res) => {
                setHistory(res.data)
                console.log('History is', res.data)
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }

    return {
        loading,
        load,
        history,
    }
}
